import { GrayImage2 } from './image';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export class GrayImage2PixelwiseFilter {
  constructor(private f: (x: number) => number) {}
  filter(img: GrayImage2) {
    const vmax = img.max();
    const vmin = img.min();
    const result = new GrayImage2(
      img.meta.center,
      img.meta.size,
      img.meta.shape,
      img.data.map(x => (x - vmin) / (vmax - vmin)).map(x => this.f(x)),
    );
    return result;
  }
}

export class GrayImage2ScaleOffsetFilter extends GrayImage2PixelwiseFilter {
  constructor(scale: number, offset: number) {
    super(x => x * scale + offset);
  }
}

export class GrayImage2WindowFilter extends GrayImage2PixelwiseFilter {
  constructor(public width: number, public level: number) {
    super(
      // (x) => Math.min(Math.max(x, level - width / 2), level + width / 2) / width
      x => Math.min(Math.max(x, level - width / 2), level + width / 2),
    );
  }
  updateLevel(l: number) {
    return new GrayImage2WindowFilter(this.width, l);
  }
  updataWidth(w: number) {
    return new GrayImage2WindowFilter(w, this.level);
  }
  addWidth(a: number) {
    return new GrayImage2WindowFilter(this.width + a, this.level);
  }
  addLevel(a: number) {
    return new GrayImage2WindowFilter(this.width, this.level + a);
  }
  addWidthLevel(addWidth: number , addLevel: number) {
    return this.addWidth(addWidth).addLevel(addLevel);
  }
}

export function applyFilters(
  image2: Observable<GrayImage2>,
  filter: Observable<GrayImage2PixelwiseFilter[]>,
) {
  return combineLatest(filter, image2).pipe(
    map(x => {
      const fil = x[0];
      let img = x[1];
      fil.forEach(f => {
        img = f.filter(img);
      });
      return img;
    }),
  );
}
